exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmsInput {\n\tbackground-color: black;\n\tcolor: #f3bb45;\n\tcursor: pointer;\n\tfont-family: monospace;\n\tfont-size: 24px;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\tpadding-top: 0;\n\t-webkit-user-select: none;\n\t   -moz-user-select: none;\n\t    -ms-user-select: none;\n\t        user-select: none;\n}\n\n.page-preview__flash {\n\tmargin: 0 auto;\n\tmargin-top: 5px;\n}\n\n.page-preview,\n.page-preview label {\n\tcursor: pointer;\n}\n\n.page-preview label {\n\tmargin: 0;\n}\n\n.highlight {\n\tborder: 3px solid #f3b941;\n\tbackground-color: rgb(249, 244, 199);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/page-preview/page-preview.component.css
// module id = ../../../../../src/app/page-preview/page-preview.component.css
// module chunks = main